import { t } from "@lingui/core/macro";
import invariant from "tiny-invariant";

import { CropCategory } from "@/generated/digitalnisklady.cz/graphql";

const categories = new Map<CropCategory, () => string>();
categories.set(CropCategory.Eko, () => t`Biostimulanty`);
categories.set(CropCategory.Feed, () => t`Krmiva`);
categories.set(CropCategory.Fertilizer, () => t`Hnojiva`);
categories.set(CropCategory.Fuel, () => t`Pohonné hmoty a maziva`);
categories.set(CropCategory.PlantProtection, () => t`Postřiky`);
categories.set(CropCategory.Seed, () => t`Osiva`);

const getCategory = (category: CropCategory) => {
  const translation = categories.get(category);
  //
  // eslint-disable-next-line lingui/no-unlocalized-strings
  invariant(translation, `Unknown crop category: ${category}`);

  return translation();
};

// Define custom category order for display
const categoryOrder: CropCategory[] = [
  CropCategory.Fertilizer, // Hnojiva
  CropCategory.PlantProtection, // Postřiky
  CropCategory.Feed, // Krmiva
  CropCategory.Seed, // Osiva
  CropCategory.Fuel, // PHM
  CropCategory.Eko, // Eko
];

const getCategoryOrder = (category: CropCategory): number => {
  const index = categoryOrder.indexOf(category);
  return index === -1 ? Number.MAX_SAFE_INTEGER : index;
};

export { categories, categoryOrder, getCategory, getCategoryOrder };
